import ApiService from '@/plugins/api-plugin/services/api.service'
import { AmazonFinancialEventsDao } from '@/interfaces/payments/AmazonFinancialEvents.dao'
import { PaymentTransactionsLookupDao } from '@/interfaces/payments/PaymentTransaction.dao'
import {
    UploadedPaymentTransactionDao,
    UploadPaymentTransactionDto,
} from '@/interfaces/payments/UploadPaymentTransaction.dto'

export default class PaymentsService extends ApiService {
    /**
     * Looks stored transactions up by reference. POST because an uploaded report carries up to 4000
     * references, which do not fit in a query string.
     */
    async lookupPaymentTransactions(transactionReferences: string[]): Promise<PaymentTransactionsLookupDao | null> {
        return this.request<{ transactionReferences: string[] }, PaymentTransactionsLookupDao | null>(
            'POST',
            '/payments/transactions/lookup',
            undefined,
            { transactionReferences },
            undefined,
            'lookupPaymentTransactions',
        ).catch(() => null)
    }

    async uploadPaymentTransactions(
        transactions: UploadPaymentTransactionDto[],
    ): Promise<UploadedPaymentTransactionDao[] | null> {
        return this.request<{ transactions: UploadPaymentTransactionDto[] }, UploadedPaymentTransactionDao[] | null>(
            'POST',
            '/payments/transactions/upload',
            undefined,
            { transactions },
            undefined,
            'uploadPaymentTransactions',
        ).catch(() => null)
    }

    async getAmazonFinancialEvents(params: {
        accountNames: string[]
        startDate: string
        endDate: string
    }): Promise<AmazonFinancialEventsDao | null> {
        return this.request<undefined, AmazonFinancialEventsDao | null>(
            'GET',
            '/payments/amazon-financial-events',
            params,
            undefined,
            undefined,
            'getAmazonFinancialEvents',
        ).catch(() => null)
    }
}
